module.exports = __webpack_public_path__ + "img/grand-resort-4.678f3a53.jpg";